import Google from "./Google/Google";

function App() {
  return (
    <>
      <Google />
    </>
  );
}

export default App;
